import type { RdoSummary } from "../types.ts";
import { formatRdoDate, formatRdoIssuedAt } from "./format.ts";

export function rdosAffectedByMeasurement(
	rdos: RdoSummary[],
	measuredOn: string,
): RdoSummary[] {
	return rdos
		.filter(
			(rdo) =>
				rdo.status === "finalized" &&
				rdo.performanceEnabled &&
				rdo.reportDate >= measuredOn,
		)
		.sort((a, b) => a.reportDate.localeCompare(b.reportDate));
}

export function affectedRdosWarning(rdos: RdoSummary[]): string {
	const [first] = rdos;
	if (!first) return "";
	if (rdos.length === 1) {
		const issuedAt = first.finalizedAt
			? ` em ${formatRdoIssuedAt(first.finalizedAt)}`
			: "";
		return (
			`O RDO nº ${first.sequenceNumber} de ${formatRdoDate(first.reportDate)} ` +
			`já foi emitido${issuedAt} e não inclui esta medição. ` +
			"Depois de salvar, abra uma revisão do relatório para atualizá-lo."
		);
	}
	const numbers = rdos.map((rdo) => rdo.sequenceNumber).join(", ");
	return (
		`${rdos.length} RDOs já emitidos a partir de ${formatRdoDate(first.reportDate)} ` +
		`(nº ${numbers}) não incluem esta medição. ` +
		"Depois de salvar, abra uma revisão dos relatórios para atualizá-los."
	);
}
